export enum ModalType {
  CONFIRM = 'confirm',
  VIEW_CONVERSATION = 'view_conversation',
  ADD_TO_BLOCKLIST = 'add_to_blocklist',
  MODERATION_SESSION_EXPIRED = 'moderation_session_expired',
  AUDIT_LOG = 'audit_log',
  ASSIGN_GROUP = 'assign_group',
  CONFIRM_GENERAL = 'confirm_general'
}

export interface IModal {
  modalType: ModalType;
  modalProps: any;
}

export interface IModalState {
  currentModals: IModal[];
}
